export default __webpack_public_path__ + "static/media/krilnekapije6.7383d3a0.jpg";